import React, { useState } from 'react';
import { Form, Modal, Upload } from '@maxtropy/components';
import { Col, Row, Spin, Typography, Upload as AntdUpload } from 'antd';
import { useParams } from 'react-router-dom';
import { apiV2PeriodDetailImportPost } from '@maxtropy/device-customer-apis-v2';

type ImportPeriodModalProps = {
  open: boolean;

  closeModal: () => void;
  forceUpdate: () => void;
};

// 导入排班
export default function ImportPeriodModal(props: ImportPeriodModalProps) {
  const { open, closeModal, forceUpdate } = props;
  const [form] = Form.useForm();
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const { id } = useParams();

  return (
    <>
      <Modal
        size="normal"
        contentClassName="modal-form-content"
        open={open}
        title="导入时段"
        onCancel={() => {
          closeModal();
        }}
        onOk={() => {
          form.submit();
        }}
        okButtonProps={{
          disabled: isUploading,
        }}
        cancelButtonProps={{
          disabled: isUploading,
        }}
        okText="导入"
      >
        <Form
          form={form}
          onFinish={(v: any) => {
            const fileKey = v.fileKey;
            if (fileKey) {
              setIsUploading(true);
              apiV2PeriodDetailImportPost({
                dataQueryPeriodId: Number(id),
                fileKey: fileKey,
              })
                .then(res => {
                  Modal.success({
                    content: '导入成功',
                  });
                })
                .finally(() => {
                  setIsUploading(false);
                  forceUpdate();
                  closeModal();
                });
            } else {
              form.setFields([{ name: 'fileKey', errors: ['请选择文件'] }]);
            }
          }}
        >
          <Spin spinning={isUploading}>
            <Row justify="start" style={{ marginBottom: '20px' }}>
              <Col>
                <Typography.Link
                  onClick={() => {
                    window.open(`/api/v2/period/detail/download`, '__blank');
                  }}
                >
                  下载模板
                </Typography.Link>
              </Col>
            </Row>

            <Form.Item
              name="fileKey"
              label="上传文件"
              rules={[{ required: true, message: '请选择文件' }]}
              extra="限制格式为xls或xlsx，不超过20MB"
            >
              <Upload
                action="/api/file-center/upload"
                accept={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
                maxCount={1}
                listType="text"
                beforeUpload={file => {
                  const isLt20M = file.size / 1024 / 1024 < 20;
                  const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                  if (!isLt20M) {
                    Modal.warning({
                      content: '上传文件的大小不得超过20M',
                    });
                  }
                  if (!isXLSX) {
                    Modal.warning({
                      content: '文件格式错误！仅支持.xlsx',
                    });
                  }
                  return (isLt20M && isXLSX) || AntdUpload.LIST_IGNORE;
                }}
              ></Upload>
            </Form.Item>
          </Spin>
        </Form>
      </Modal>
    </>
  );
}
